"use client";

import { memo } from "react";
import {
  useA2UIComponent,
  type A2UIComponentProps,
  type Types,
} from "@a2ui/react";

function getYouTubeVideoId(url: string): string | null {
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\s?]+)/,
  ];
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match?.[1]) return match[1];
  }
  return null;
}

export const BeeOSVideo = memo(function BeeOSVideo({
  node,
  surfaceId,
}: A2UIComponentProps<Types.VideoNode>) {
  const { resolveString } = useA2UIComponent(node, surfaceId);
  const props = node.properties;
  const url = resolveString(props.url);

  if (!url) return null;

  const youtubeId = getYouTubeVideoId(url);

  const hostStyle: React.CSSProperties =
    node.weight !== undefined ? ({ "--weight": node.weight } as React.CSSProperties) : {};

  return (
    <div className="a2ui-video" style={hostStyle}>
      <div className="rounded-lg overflow-hidden border border-border/30">
        {youtubeId ? (
          <iframe
            src={`https://www.youtube.com/embed/${youtubeId}`}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full aspect-video border-0"
          />
        ) : (
          <video src={url} controls className="w-full aspect-video" />
        )}
      </div>
    </div>
  );
});
